/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
// @ts-ignore
import Parse from 'parse';
// @ts-ignore
import { IHosportsFooterViewProps } from '../../../modules/hosports-footer/./hosports-footer';
// @ts-ignore
import MailchimpSubscribe from "react-mailchimp-subscribe"
// @ts-ignore
import {GeneralAssetUrl} from '../utilities/constants';
// @ts-ignore
import {initAnalytics} from '../utilities/analytics';

/**
 *
 * Hero component
 * @extends {React.Component<IHosportsFooterViewProps<IHosportsFooterViewData>}
 */
class HoSportsFooter extends React.Component<IHosportsFooterViewProps> {

  public render(): JSX.Element {
    const { config } = this.props;
    if(config.googleAnalyticsCode){
      initAnalytics(config.googleAnalyticsCode)
    }
    console.log(config)
    if(config.blockSiteFromPublic){
      if(!Parse.User.current() || Parse.User.current().id != config.blockSiteFromPublicAcceptedUserId){
        if(window.location.pathname.indexOf('retailer-login') == -1){
          if(window.location.search){
            window.location.assign('/retailer-login/'+window.location.search)
          } else{
            window.location.assign('/retailer-login/')
          }
        }
      }
    }
    return (
      <div className={'footer '+config.theme}>
        <div className="site-gutter">
          <div className="row top-row">
            <div className="small-12 medium-4">
              {config.newsletterCTA && <h5 className="newsletter-cta">{config.newsletterCTA}</h5>}
            </div>
            <div className="small-12 medium-4 newsletter-form">
              {config.mailchimpUrl &&
                <div className="mailchimp-container centered-text">
                  <div className="full-width">
                    <MailchimpSubscribe url={config.mailchimpUrl}/>
                  </div>
                  <div style={{"clear":"both"}}></div>
                </div>
              }
            </div>
            <div className="small-12 medium-4 link-list">
              {config.topRowLinkList && config.topRowLinkList.map((data:any) =>{
                return(<a href={data.linkUrl}>{data.linkText}</a>)
              })}
            </div>
          </div>
          <div className="row middle-row">
            {(config.logo ||
              config.companyName)
              &&
              <div className="small-12 medium-3">
                {config.logo && config.logo.src && <img className="company-logo" src={config.logo.src} />}
                {config.companyName && <h5 className="company-name">{config.companyName}</h5>}
                {config.addressStreet && <p className="company-address">{config.addressStreet}<br />
                  {config.addressCity && config.addressCity}
                  {config.addressState && ', '+config.addressState}
                  {config.addressZip && ' '+config.addressZip}
                </p>}
                {config.phone && <a href={"tel:"+config.phone}><p className="company-phone">{config.phone}</p></a>}
                {config.email && <a href={"mailto:"+config.email}><p className="company-email">{config.email}</p></a>}
              </div>
            }
            {(config.middleRowLinkColumn1Title || config.middleRowLinkColumn1LinkList) &&
              <div className="small-12 medium-3 middle-row-column">
                {config.middleRowLinkColumn1Title && <h5 className="footer-column-title">{config.middleRowLinkColumn1Title}</h5>}
                {config.middleRowLinkColumn1LinkList && config.middleRowLinkColumn1LinkList.map((data:any) =>{
                  return(<span><a className="footer-link" href={data.linkUrl?.destinationUrl}>{data.linkText}</a><br /></span>)
                })}
              </div>
            }
            {(config.middleRowLinkColumn2Title || config.middleRowLinkColumn2LinkList) &&
              <div className="small-12 medium-3 middle-row-column">
                {config.middleRowLinkColumn2Title && <h5 className="footer-column-title">{config.middleRowLinkColumn2Title}</h5>}
                {config.middleRowLinkColumn2LinkList && config.middleRowLinkColumn2LinkList.map((data:any) =>{
                  return(<span><a className="footer-link" href={data.linkUrl?.destinationUrl}>{data.linkText}</a><br /></span>)
                })}
              </div>
            }
            {(config.middleRowLinkColumn3Title || config.middleRowLinkColumn3LinkList) &&
              <div className="small-12 medium-3 middle-row-column">
                {config.middleRowLinkColumn3Title && <h5 className="footer-column-title">{config.middleRowLinkColumn3Title}</h5>}
                {config.middleRowLinkColumn3LinkList && config.middleRowLinkColumn3LinkList.map((data:any) =>{
                  return(<span><a className="footer-link" href={data.linkUrl?.destinationUrl}>{data.linkText}</a><br /></span>)
                })}
              </div>
            }
          </div>
          <div className="row bottom-row">
            <div className="small-12 medium-4 centered-text">
              {config.copyrightInfo && <h5 className="newsletter-copyright-info">{config.copyrightInfo}</h5>}
            </div>
            <div className="small-12 medium-12 centered-text">
              {config.twitter && <a href={config.twitter} target="_blank"><img className="footer-social-icon" src={GeneralAssetUrl+'twitter-icon.png'} /></a>}
              {config.facebook && <a href={config.facebook} target="_blank"><img className="footer-social-icon" src={GeneralAssetUrl+'facebook-icon.png'} /></a>}
              {config.instagram && <a href={config.instagram} target="_blank"><img className="footer-social-icon" src={GeneralAssetUrl+'instagram-icon.png'} /></a>}
              {config.youtube && <a href={config.youtube} target="_blank"><img className="footer-social-icon" src={GeneralAssetUrl+'youtube-icon.png'} /></a>}
            </div>
            <div className="small-12 medium-12 link-list centered-text">
              {config.bottomRowLinkList && config.bottomRowLinkList.map((data:any) =>{
                return(<a href={data.linkUrl?.destinationUrl}><div className="bottom-row-link">{data.linkText}</div></a>)
              })}
            </div>
          </div>
        </div>
      </div>
    )
  }
};

export default HoSportsFooter;
